import { formatDate, formatDateISO } from '@helpers/date';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import CtaLink from '@stories/Components/Buttons/CtaLink/CtaLink';
import * as React from 'react';
import S from './ArticleCard.styles';
import { linkAria } from '@helpers/utils';
const ArticleCard = (props) => {
    const srcs = props.image ? getSrcs(props.image, 730, 375, 5, 428 / 370) : [];
    const sizes = `${until(Device.Tablet)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.DesktopSmall)} 33vw, ${until(Device.DesktopLarge)} 25vw, 428px`;
    return (React.createElement(S.Container, null,
        props.image && (React.createElement(S.ImageWrapper, null,
            React.createElement(S.Img, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText ?? props.name, loading: 'lazy' }))),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDate(props.date, 'd LLL yyyy')),
            React.createElement(S.Name, null, props.name),
            props.description && React.createElement(S.Description, null, props.description),
            React.createElement(CtaLink, { "aria-label": linkAria(props.cta.text ?? '', props.cta.target, props.translations && props.translations['lcci.link.newtab']), href: props.cta.url, target: props.cta.target }, props.cta.text ?? 'Read More'))));
};
export default ArticleCard;
